const LOCALE_BY_CURRENCY = {
    CZK: "cs-CZ",
    EUR: "de-DE",
    USD: "en-US",
    GBP: "en-GB",
    HUF: "hu-HU",
};

export function formatPrice(price, currency = "CZK") {
    if (!price || price === "" || price === "null" || price === "undefined" || price === null) return "-";

    // Handle numeric prices (new decimal format)
    let numericPrice = price;

    if (typeof price === "string") {
        // Remove currency symbols, spaces, and other non-numeric characters except decimal separators
        const cleanPrice = price.replace(/[^\d.,]/g, "");

        // Handle European number format: 1.358,94 (thousands separator: ., decimal separator: ,)
        if (cleanPrice.includes(".") && cleanPrice.includes(",")) {
            // Format like 1.358,94 - period is thousands separator, comma is decimal
            const parts = cleanPrice.split(",");
            if (parts.length === 2) {
                const integerPart = parts[0].replace(/\./g, ""); // Remove thousands separators
                const decimalPart = parts[1];
                numericPrice = parseFloat(integerPart + "." + decimalPart);
            }
        } else if (cleanPrice.includes(",") && !cleanPrice.includes(".")) {
            // Format like 1358,94 - comma is decimal separator
            numericPrice = parseFloat(cleanPrice.replace(",", "."));
        } else if (cleanPrice.includes(".") && !cleanPrice.includes(",")) {
            // Format like 1358.94 - period is decimal separator
            numericPrice = parseFloat(cleanPrice);
        } else {
            // No decimal separator, just integer
            numericPrice = parseFloat(cleanPrice);
        }
    }

    if (isNaN(numericPrice) || numericPrice === null || numericPrice === undefined) {
        return "-";
    }

    const locale = LOCALE_BY_CURRENCY[currency] || LOCALE_BY_CURRENCY.CZK;
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: LOCALE_BY_CURRENCY[currency] ? currency : "CZK",
    }).format(numericPrice);
}
